var _circle, _tspan, _tspan2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "300px",
    width: "300px",
    viewBox: "-300 -300 600 600",
    fontFamily: "Bitstream Vera Sans,Liberation Sans, Arial, sans-serif",
    fontSize: 72,
    textAnchor: "middle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#AAA",
    strokeWidth: 10,
    r: 280,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#444"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: -8
  }, "NO IMAGE")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 80
  }, "AVAILABLE"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/No_image.1edd6fd364814829a6a7f0133e3bcf0b.svg";
export { ForwardRef as ReactComponent };